"use client";

import { CcDigitRollDigits } from "@/components/ui/CcDigitRoll";

const DIGIT_TARGETS = [4, 0, 4] as const;
const SESSION_KEY = "cc-not-found-count-up";

export function CcNotFoundCode() {
  return (
    <CcDigitRollDigits
      digits={DIGIT_TARGETS}
      accentDigitIndex={1}
      sessionStorageKey={SESSION_KEY}
      className="cc-not-found__code"
      aria-hidden
    />
  );
}
